import { Directive, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class SubscriptionManager implements OnDestroy {

    protected readonly closedSubject = new Subject<void>();

    public get closed$() {
        return this.closedSubject.asObservable();
    }

    /**
     * rxjs operateor to use in subclasses
     */
    public get untilDestroyed() {
        return <U>(source: Observable<U>) => {
            return source.pipe(takeUntil<U>(this.closed$));
        };
    }

    /**
     * subcribe to an observable until ngOnDestroy is called
     */
    protected set watch$(observable: Observable<any>) {
        observable.pipe(this.untilDestroyed).subscribe();
    }

    /**
     * Implémentation à garder pour que le untilDestroyed fonctionne
     */
    ngOnDestroy(): void {
        this.closedSubject.next();
        this.closedSubject.complete();
    }

}
